import { useRef, useCallback } from "react";

export function useDebounceCallback<T>(func: (arg: T) => void, delay: number) {
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  const debouncedFunc = (arg: T) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => func(arg), delay);
  };

  return useCallback(debouncedFunc, [func, delay]);
}
